import { X } from '@phosphor-icons/react'
import { IconButton } from '@shopflo/ui'
import React from 'react'
import { customizeCartUIType } from 'src/lib/types/cartUI'

interface HeaderProps {
  headerConfig: customizeCartUIType['header']
  enableShadow?: boolean
}

export const Header: React.FC<HeaderProps> = ({ headerConfig, enableShadow = false }) => {
  return (
    <div
      className='flex w-full items-center justify-between pl-5 pr-4 h-[44px] relative z-10'
      style={{
        backgroundColor: headerConfig.backgroundColor,
        boxShadow: enableShadow ? '0px 1px 5px 0px rgba(175, 175, 175, 0.3)' : 'none'
      }}
    >
      <div
        className='flex h-6 items-center gap-2 text-coal-dark'
        style={{
          color: headerConfig.textColor
        }}
      >
        <div className='flex gap-1 items-center'>
          <span className='text-eyebrow-xs'>Your Cart</span>
          <>
            <span className='text-text-xs-regular'>(2)</span>
          </>
        </div>
      </div>
      <IconButton
        variant='ghost'
        size='sm'
        IconComponent={X}
        style={{
          color: headerConfig.textColor
        }}
      />
    </div>
  )
}
